import { CustomerByCodeResponseDTO, CustomerResponseDTO, CustomerUpdateDTO, FindAllCustomerByCodeResponseDTO, FindAllCustomersFilters, findAllCustomersResponseDTO } from "./dto";
import { CustomerServiceImpl } from "./serviceImpl";

export interface CustomerService {
    getCustomers(filters: FindAllCustomersFilters): Promise<findAllCustomersResponseDTO>
    getCustomerById(id: string): Promise<CustomerResponseDTO>
    updateCustomer(id: string, data: CustomerUpdateDTO): Promise<void>
    createCustomer(data: CustomerUpdateDTO): Promise<number>
    getCustomerByCode(code: string): Promise<FindAllCustomerByCodeResponseDTO>
}

export function NewCustomerService(): CustomerService {
    return new CustomerServiceImpl();
}
